<script setup lang="ts">
	defineProps<{
		checked: boolean | string
	}>()
	const emit = defineEmits(['update:checked'])
</script>
<template>
	<label class="toggle-switch relative inline-block h-[29px] w-[58px] cursor-pointer">
		<input
			type="checkbox"
			class="hidden"
			:checked="checked as boolean"
			@change="(e: Event) => emit('update:checked', (e.target as HTMLInputElement).checked)"
		/>
		<div class="toggle-switch-background px-1">
			<div class="toggle-switch-handle"></div>
		</div>
	</label>
</template>

<style scoped>
	.toggle-switch-background {
		@apply absolute left-0 top-0 flex h-full w-full items-center justify-normal rounded-[20px] border border-gray-200 bg-gray-300 transition ease-linear;
	}

	.toggle-switch-handle {
		transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
		@apply h-[23.2px] w-[23.2px] rounded-full bg-white shadow-[0_2px_5px_rgba(0_0_0_0.5)];
	}

	.toggle-switch input[type='checkbox']:checked + .toggle-switch-background {
		@apply border-primary-400 bg-primary-2;
	}

	.toggle-switch input[type='checkbox']:checked + .toggle-switch-background .toggle-switch-handle {
		box-shadow: -5px 3px 15px rgba(0, 0, 0, 0.18);
		@apply translate-x-[25px];
	}
</style>
